module.exports = __webpack_public_path__ + "img/icon-clipping-white.78ba456.svg";